import React from "react";
import { Link } from "gatsby"
import {
  Box,
  Stack,
  Heading,
  Flex,
  Text,
  useDisclosure
} from "@chakra-ui/react";
import { HamburgerIcon } from "@chakra-ui/icons";

import { ColorModeSwitcher } from '../ColorModeSwitcher';

const Header = ({ siteTitle = 'Title' }) => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const handleToggle = () => (isOpen ? onClose() : onOpen());

  return (
    <Flex
      as="nav"
      align="center"
      justify="space-between"
      wrap="wrap"
      padding={6}
    >
      <Flex align="center" mr={5}>
        <Link to='/'>
          <Heading as="h1" size="lg" letterSpacing={"tighter"}>
            {siteTitle}
          </Heading>
        </Link>
      </Flex>

      <Box display={{ base: "block", md: "none" }} onClick={handleToggle}>
        <HamburgerIcon />
      </Box>

      <Stack
        direction={{ base: "column", md: "row" }}
        display={{ base: isOpen ? "block" : "none", md: "flex" }}
        width={{ base: "full", md: "auto" }}
        alignItems="center"
        flexGrow={1}
        mt={{ base: 4, md: 0 }}
      >
        <Link to="/privacy-policy/">
          <Text>Privacy Policy</Text>
        </Link>
        <Link to="/terms-of-service/">
          <Text>Terms of Service</Text>
        </Link>
      </Stack>

      <Box
        display={{ base: isOpen ? "block" : "none", md: "block" }}
        mt={{ base: 4, md: 0 }}
      >
        <ColorModeSwitcher />
        {/* <Button
          variant="outline"
          _hover={{ bg: "teal.700", borderColor: "teal.700" }}
        >
          Create account
          </Button> */}
      </Box>
    </Flex>
  );
};

export default Header;
